import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { App } from '@capacitor/app';

import Alert from '../../UI/Alert';

const FORCE_EXIT_ROUTES = ['/auth'];
const EXIT_WITH_ALERT_ROUTES = ['/tabs/home'];

const HandleBackButton: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const isForceExitRoute = FORCE_EXIT_ROUTES.includes(location.pathname);
  const isExitWithAlertRoute = EXIT_WITH_ALERT_ROUTES.includes(location.pathname);

  const handleBackButton = useCallback(() => {
    // 🔴 Cierre inmediato (ej: /auth)
    if (isForceExitRoute) {
      App.exitApp();
      return;
    }

    // 🟡 Cierre con confirmación
    if (isExitWithAlertRoute) {
      setShowAlert(true);
      return;
    }

    // 🟢 Navegación normal
    if (history.length > 1) {
      history.goBack();
    } else {
      setShowAlert(true);
    }
  }, [isForceExitRoute, isExitWithAlertRoute, history]);

  useEffect(() => {
    const handleIonBackButton = (ev: any) => {
      ev.detail.register(10, () => {
        handleBackButton();
      });
    };

    document.addEventListener('ionBackButton', handleIonBackButton);
    return () => {
      document.removeEventListener('ionBackButton', handleIonBackButton);
    };
  }, [handleBackButton]);

  return (
    <Alert
      isOpen={showAlert}
      onDidDismiss={() => setShowAlert(false)}
      header="Espere"
      message="¿Está seguro que desea salir de la aplicación?"
      buttons={[
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Salir',
          handler: () => App.exitApp(),
        },
      ]}
    />
  );
};

export default HandleBackButton;
